"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const text_1 = require("../../fields/text");
const botones_1 = require("../../botones");
const mappings_1 = require("./mappings");
const keautils_1 = require("keautils");
const export_1 = require("./export");
/**True si el mapeo actual es equivalente al mapeo original */
function tieneTodasColumnas(x, originalColumnKeys) {
    return keautils_1.setEquals(originalColumnKeys, x);
}
exports.tieneTodasColumnas = tieneTodasColumnas;
const faSearch = React.createElement("i", { className: "fa fa-search" });
/**Compoonente que muestra el texto de búsqueda y el botón para descargar CSV */
class GridBusquedaComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleBusquedaChange = (value) => {
            const oldValue = this.props.value;
            const newValue = Object.assign({}, oldValue, { filtroOrden: Object.assign({}, oldValue.filtroOrden, { busqueda: value }) });
            this.props.onChange(newValue);
        };
        this.handleOnExportChange = (value) => {
            const oldValue = this.props.value;
            const newValue = Object.assign({}, oldValue, { export: value });
            this.props.onChange(newValue);
        };
        this.onColumnasClick = () => this.setState({ showMappingModal: true });
        this.onDescargarCSV = () => this.setState({ showExportarModal: true });
        this.onMappingCompClose = () => this.setState({ showMappingModal: false });
        this.onExportarCerrar = () => this.setState({ showExportarModal: false });
        this.state = { showMappingModal: false, showExportarModal: false };
    }
    render() {
        const { props, state } = this;
        const mapeoOriginal = tieneTodasColumnas(props.value.mapping, Object.keys(props.columnas));
        return (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
            React.createElement("div", { style: { flex: "1 1 auto" } },
                React.createElement(text_1.Text, { value: this.props.value.filtroOrden.busqueda, placeholder: "B\u00FAsqueda", onChange: this.handleBusquedaChange, addon: faSearch })),
            React.createElement("div", { style: { flex: "0 1 auto" } },
                React.createElement(botones_1.Button, { tooltip: "Columnas", style: mapeoOriginal ? "info" : "warning", iconClass: "fa fa-columns", onClick: this.onColumnasClick })),
            React.createElement("div", { style: { flex: "0 1 auto" } },
                React.createElement(botones_1.Button, { tooltip: "Descargar CSV", style: "success", iconClass: "fa fa-download", onClick: this.onDescargarCSV })),
            React.createElement(mappings_1.MappingComponent, { columnas: props.columnas, onClose: this.onMappingCompClose, onStateChange: props.onChange, state: props.value, show: state.showMappingModal }),
            this.state.showExportarModal &&
                React.createElement(export_1.ExportComp, { columnas: props.columnas, onCerrar: this.onExportarCerrar, mapping: props.value.export, onMappingChange: this.handleOnExportChange, onExportar: this.props.onExpotar })));
    }
}
exports.GridBusquedaComponent = GridBusquedaComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/busqueda.js
// module id = 2214
// module chunks = 0